<script>
  import Icon from '$lib/components/Icon.svelte';
  import { closeModal } from '$lib/features/app/modals';
  import { videoEventHistoryOptions } from '$lib/features/video-meeting/services';
  import {
    activeCalendarEvent,
    closeVideoHistory,
    videoHistoryExpanded,
  } from '$lib/features/video-meeting/store';
  import { createQuery } from '@tanstack/svelte-query';
  import { toStore } from 'svelte/store';
  import { twMerge } from 'tailwind-merge';
  import VideoHistoryDiagnostic from './VideoHistoryDiagnostic.svelte';
  import VideoHistoryEvent from './VideoHistoryEvent.svelte';
  let width = $derived($videoHistoryExpanded ? '480px' : '0');

  const videoEventHistory = createQuery(
    toStore(() => ({
      ...videoEventHistoryOptions({ id: $activeCalendarEvent?.id }),
      enabled: !!$activeCalendarEvent?.id,
    })),
  );

  function resize(e) {
    const ww = window.innerWidth;
    width = `${ww - e.clientX}px`;
  }

  /**
   * Stops the resizing of the video sidebar.
   */
  function stopResize() {
    document.removeEventListener('mousemove', resize);
    document.removeEventListener('mouseup', stopResize);
    document.body.classList.remove('disable-select');
  }

  /**
   * Starts the resizing of the video sidebar.
   */
  function startResize() {
    document.addEventListener('mousemove', resize);
    document.addEventListener('mouseup', stopResize);
    document.body.classList.add('disable-select');
  }

  function closeVideoHistorySidebar() {
    closeVideoHistory();
    closeModal();
  }
</script>

<div
  class={twMerge(
    'sticky top-0 -mr-px flex h-full max-h-screen flex-col',
    !$videoHistoryExpanded && 'hidden',
  )}
  style={`width: ${width}`}
>
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div
    class="absolute bottom-0 top-0 w-2 cursor-col-resize border-l border-gray-8 hover:border-gray-7"
    onmousedown={startResize}
  ></div>
  <div class="flex flex-col items-start justify-start gap-4 p-4">
    <div class="flex h-8 w-full items-center gap-4">
      <button onclick={closeVideoHistorySidebar}>
        <Icon icon="close" />
      </button>
    </div>
    {#if $videoHistoryExpanded}
      <div
        class="flex h-full max-h-[calc(100vh-6rem)] w-full flex-1 flex-col gap-4 overflow-hidden overflow-y-auto p-4"
      >
        <div class="border-l border-dashed border-gray-8">
          {#if $videoEventHistory?.data}
            {#if $videoEventHistory.data.length > 0}
              {#each $videoEventHistory.data as event}
                <VideoHistoryEvent
                  status_message={event.statusMessage}
                  time={event.createdAt}
                  metadata={event.metadata}
                  participant={event.participant}
                  roomName={event.dailycoRoomName}
                  isPatient={event.isPatient}
                />
                {#if event.statusMessage === 'DIAGNOSTIC_COLLECTED'}
                  <VideoHistoryDiagnostic data={JSON.parse(event.metadata)} />
                {/if}
              {/each}
            {:else}
              <div class="text-center text-sm text-gray-500">
                Inga händelser hittades
              </div>
            {/if}
          {:else}
            <div class="text-center text-sm text-gray-500">
              Inga händelser hittades
            </div>
          {/if}
        </div>
      </div>
    {/if}
  </div>
</div>
